// NTEE (National Taxonomy of Exempt Entities) codes and descriptions
const NTEECodes = [
  // A: Arts, Culture & Humanities
  { code: "A", description: "Arts, Culture & Humanities" },
  { code: "A01", description: "Alliances & Advocacy" },
  { code: "A02", description: "Management & Technical Assistance" },
  { code: "A03", description: "Professional Societies & Associations" },
  { code: "A05", description: "Research Institutes & Public Policy Analysis" },
  { code: "A11", description: "Single Organization Support" },
  { code: "A12", description: "Fund Raising & Fund Distribution" },
  { code: "A19", description: "Support - Other" },
  { code: "A20", description: "Arts & Culture" },
  { code: "A23", description: "Cultural & Ethnic Awareness" },
  { code: "A24", description: "Folk Arts" },
  { code: "A25", description: "Arts Education" },
  { code: "A26", description: "Arts & Humanities Councils & Agencies" },
  { code: "A27", description: "Community Celebrations" },
  { code: "A30", description: "Media & Communications" },
  { code: "A31", description: "Film & Video" },
  { code: "A32", description: "Television" },
  { code: "A33", description: "Printing & Publishing" },
  { code: "A34", description: "Radio" },
  { code: "A40", description: "Visual Arts" },
  { code: "A50", description: "Museums" },
  { code: "A51", description: "Art Museums" },
  { code: "A52", description: "Children's Museums" },
  { code: "A53", description: "Folk Arts Museums" },
  { code: "A54", description: "History Museums" },
  { code: "A56", description: "Natural History & Natural Science Museums" },
  { code: "A57", description: "Science & Technology Museums" },
  { code: "A60", description: "Performing Arts" },
  { code: "A61", description: "Performing Arts Centers" },
  { code: "A62", description: "Dance" },
  { code: "A63", description: "Ballet" },
  { code: "A65", description: "Theater" },
  { code: "A68", description: "Music" },
  { code: "A69", description: "Symphony Orchestras" },
  { code: "A6A", description: "Opera" },
  { code: "A6B", description: "Singing & Choral Groups" },
  { code: "A6C", description: "Bands & Ensembles" },
  { code: "A6E", description: "Performing Arts Schools" },
  { code: "A70", description: "Humanities" },
  { code: "A80", description: "Historical Organizations" },
  { code: "A82", description: "Historical Societies & Historic Preservation" },
  { code: "A84", description: "Commemorative Events" },
  { code: "A90", description: "Arts Services" },
  { code: "A99", description: "Arts, Culture & Humanities - Other" },
  
  // B: Education
  { code: "B", description: "Education" },
  { code: "B01", description: "Alliances & Advocacy" },
  { code: "B02", description: "Management & Technical Assistance" },
  { code: "B03", description: "Professional Societies & Associations" },
  { code: "B05", description: "Research Institutes & Public Policy Analysis" },
  { code: "B11", description: "Single Organization Support" },
  { code: "B12", description: "Fund Raising & Fund Distribution" },
  { code: "B19", description: "Support - Other" },
  { code: "B20", description: "Elementary & Secondary Education" },
  { code: "B21", description: "Preschools" },
  { code: "B24", description: "Primary & Elementary Schools" },
  { code: "B25", description: "Secondary & High Schools" },
  { code: "B28", description: "Special Education" },
  { code: "B29", description: "Charter Schools" },
  { code: "B30", description: "Vocational & Technical Schools" },
  { code: "B40", description: "Higher Education" },
  { code: "B41", description: "Two-Year Colleges" },
  { code: "B42", description: "Undergraduate Colleges" },
  { code: "B43", description: "Universities" },
  { code: "B50", description: "Graduate & Professional Schools" },
  { code: "B60", description: "Adult Education" },
  { code: "B70", description: "Libraries" },
  { code: "B80", description: "Student Services" },
  { code: "B82", description: "Scholarships & Student Financial Aid" },
  { code: "B83", description: "Student Sororities & Fraternities" },
  { code: "B84", description: "Alumni Associations" },
  { code: "B90", description: "Educational Services" },
  { code: "B92", description: "Remedial Reading & Encouragement" },
  { code: "B94", description: "Parent & Teacher Groups" },
  { code: "B99", description: "Education - Other" },
  
  // C: Environment
  { code: "C", description: "Environment" },
  { code: "C01", description: "Alliances & Advocacy" },
  { code: "C02", description: "Management & Technical Assistance" },
  { code: "C03", description: "Professional Societies & Associations" },
  { code: "C05", description: "Research Institutes & Public Policy Analysis" },
  { code: "C11", description: "Single Organization Support" },
  { code: "C12", description: "Fund Raising & Fund Distribution" },
  { code: "C19", description: "Support - Other" },
  { code: "C20", description: "Pollution Abatement & Control" },
  { code: "C27", description: "Recycling" },
  { code: "C30", description: "Natural Resources Conservation & Protection" },
  { code: "C32", description: "Water Resources, Wetlands Conservation & Management" },
  { code: "C34", description: "Land Resources Conservation" },
  { code: "C35", description: "Energy Resources Conservation & Development" },
  { code: "C36", description: "Forest Conservation" },
  { code: "C40", description: "Botanical, Horticultural & Landscape Services" },
  { code: "C41", description: "Botanical Gardens & Arboreta" },
  { code: "C42", description: "Garden Clubs" },
  { code: "C50", description: "Environmental Beautification" },
  { code: "C60", description: "Environmental Education" },
  { code: "C99", description: "Environment - Other" },
  
  // D: Animal-Related
  { code: "D", description: "Animal-Related" },
  { code: "D01", description: "Alliances & Advocacy" },
  { code: "D02", description: "Management & Technical Assistance" },
  { code: "D03", description: "Professional Societies & Associations" },
  { code: "D05", description: "Research Institutes & Public Policy Analysis" },
  { code: "D11", description: "Single Organization Support" },
  { code: "D12", description: "Fund Raising & Fund Distribution" },
  { code: "D19", description: "Support - Other" },
  { code: "D20", description: "Animal Protection & Welfare" },
  { code: "D30", description: "Wildlife Preservation & Protection" },
  { code: "D31", description: "Protection of Endangered Species" },
  { code: "D32", description: "Bird Sanctuaries" },
  { code: "D33", description: "Fisheries Resources" },
  { code: "D34", description: "Wildlife Sanctuaries" },
  { code: "D40", description: "Veterinary Services" },
  { code: "D50", description: "Zoos & Aquariums" },
  { code: "D60", description: "Animal Services - Other" },
  { code: "D61", description: "Animal Training" },
  { code: "D99", description: "Animal-Related - Other" },
  
  // E: Health Care
  { code: "E", description: "Health Care" },
  { code: "E01", description: "Alliances & Advocacy" },
  { code: "E02", description: "Management & Technical Assistance" },
  { code: "E03", description: "Professional Societies & Associations" },
  { code: "E05", description: "Research Institutes & Public Policy Analysis" },
  { code: "E11", description: "Single Organization Support" },
  { code: "E12", description: "Fund Raising & Fund Distribution" },
  { code: "E19", description: "Support - Other" },
  { code: "E20", description: "Hospitals" },
  { code: "E21", description: "Community Health Systems" },
  { code: "E22", description: "General Hospitals" },
  { code: "E24", description: "Specialty Hospitals" },
  { code: "E30", description: "Ambulatory & Primary Health Care" },
  { code: "E31", description: "Group Health Practices" },
  { code: "E32", description: "Community Clinics" },
  { code: "E40", description: "Reproductive Health Care" },
  { code: "E42", description: "Family Planning" },
  { code: "E50", description: "Rehabilitative Care" },
  { code: "E60", description: "Health Support Services" },
  { code: "E61", description: "Blood Banks" },
  { code: "E62", description: "Emergency Medical Services & Transport" },
  { code: "E65", description: "Organ & Tissue Banks" },
  { code: "E70", description: "Public Health" },
  { code: "E80", description: "Health (General & Financing)" },
  { code: "E86", description: "Patient & Family Support" },
  { code: "E90", description: "Nursing" },
  { code: "E91", description: "Nursing Facilities" },
  { code: "E92", description: "Home Health Care" },
  { code: "E99", description: "Health Care - Other" },
  
  // F: Mental Health & Crisis Intervention
  { code: "F", description: "Mental Health & Crisis Intervention" },
  { code: "F01", description: "Alliances & Advocacy" },
  { code: "F02", description: "Management & Technical Assistance" },
  { code: "F03", description: "Professional Societies & Associations" },
  { code: "F05", description: "Research Institutes & Public Policy Analysis" },
  { code: "F11", description: "Single Organization Support" },
  { code: "F12", description: "Fund Raising & Fund Distribution" },
  { code: "F19", description: "Support - Other" },
  { code: "F20", description: "Substance Abuse Prevention & Treatment" },
  { code: "F21", description: "Substance Abuse Prevention" },
  { code: "F22", description: "Substance Abuse Treatment" },
  { code: "F30", description: "Mental Health Treatment" },
  { code: "F31", description: "Psychiatric Hospitals" },
  { code: "F32", description: "Community Mental Health Centers" },
  { code: "F33", description: "Residential Mental Health Treatment" },
  { code: "F40", description: "Hot Lines & Crisis Intervention" },
  { code: "F42", description: "Sexual Assault Services" },
  { code: "F50", description: "Addictive Disorders" },
  { code: "F52", description: "Smoking Addiction" },
  { code: "F53", description: "Eating Disorders & Addictions" },
  { code: "F54", description: "Gambling Addiction" },
  { code: "F60", description: "Counseling" },
  { code: "F70", description: "Mental Health Disorders" },
  { code: "F80", description: "Mental Health Associations" },
  { code: "F99", description: "Mental Health & Crisis Intervention - Other" },
  
  // G: Voluntary Health Associations & Medical Disciplines
  { code: "G", description: "Voluntary Health Associations & Medical Disciplines" },
  { code: "G01", description: "Alliances & Advocacy" },
  { code: "G02", description: "Management & Technical Assistance" },
  { code: "G03", description: "Professional Societies & Associations" },
  { code: "G05", description: "Research Institutes & Public Policy Analysis" },
  { code: "G11", description: "Single Organization Support" },
  { code: "G12", description: "Fund Raising & Fund Distribution" },
  { code: "G19", description: "Support - Other" },
  { code: "G20", description: "Birth Defects & Genetic Diseases" },
  { code: "G25", description: "Down Syndrome" },
  { code: "G30", description: "Cancer" },
  { code: "G32", description: "Breast Cancer" },
  { code: "G40", description: "Diseases of Specific Organs" },
  { code: "G41", description: "Eye Diseases, Blindness & Vision Impairments" },
  { code: "G42", description: "Ear & Throat Diseases" },
  { code: "G43", description: "Heart & Circulatory System Diseases & Disorders" },
  { code: "G44", description: "Kidney Diseases" },
  { code: "G45", description: "Lung Diseases" },
  { code: "G48", description: "Brain Disorders" },
  { code: "G50", description: "Nerve, Muscle & Bone Diseases" },
  { code: "G51", description: "Arthritis" },
  { code: "G54", description: "Epilepsy" },
  { code: "G60", description: "Allergy-Related Diseases" },
  { code: "G61", description: "Asthma" },
  { code: "G70", description: "Digestive Diseases & Disorders" },
  { code: "G80", description: "Specifically Named Diseases" },
  { code: "G81", description: "AIDS" },
  { code: "G83", description: "Alzheimer's Disease" },
  { code: "G84", description: "Autism" },
  { code: "G90", description: "Medical Disciplines" },
  { code: "G92", description: "Biomedicine & Bioengineering" },
  { code: "G94", description: "Geriatrics" },
  { code: "G96", description: "Neurology & Neuroscience" },
  { code: "G98", description: "Pediatrics" },
  { code: "G9B", description: "Surgery" },
  { code: "G99", description: "Voluntary Health Associations & Medical Disciplines - Other" },
  
  // H: Medical Research
  { code: "H", description: "Medical Research" },
  { code: "H01", description: "Alliances & Advocacy" },
  { code: "H02", description: "Management & Technical Assistance" },
  { code: "H03", description: "Professional Societies & Associations" },
  { code: "H05", description: "Research Institutes & Public Policy Analysis" },
  { code: "H11", description: "Single Organization Support" },
  { code: "H12", description: "Fund Raising & Fund Distribution" },
  { code: "H19", description: "Support - Other" },
  { code: "H20", description: "Birth Defects & Genetic Diseases Research" },
  { code: "H25", description: "Down Syndrome Research" },
  { code: "H30", description: "Cancer Research" },
  { code: "H32", description: "Breast Cancer Research" },
  { code: "H40", description: "Diseases of Specific Organs Research" },
  { code: "H41", description: "Eye Diseases, Blindness & Vision Impairments Research" },
  { code: "H42", description: "Ear & Throat Diseases Research" },
  { code: "H43", description: "Heart & Circulatory System Diseases & Disorders Research" },
  { code: "H44", description: "Kidney Diseases Research" },
  { code: "H45", description: "Lung Diseases Research" },
  { code: "H48", description: "Brain Disorders Research" },
  { code: "H50", description: "Nerve, Muscle & Bone Diseases Research" },
  { code: "H51", description: "Arthritis Research" },
  { code: "H54", description: "Epilepsy Research" },
  { code: "H60", description: "Allergy-Related Diseases Research" },
  { code: "H61", description: "Asthma Research" },
  { code: "H70", description: "Digestive Diseases & Disorders Research" },
  { code: "H80", description: "Specifically Named Diseases Research" },
  { code: "H81", description: "AIDS Research" },
  { code: "H83", description: "Alzheimer's Disease Research" },
  { code: "H84", description: "Autism Research" },
  { code: "H90", description: "Medical Specialty Research" },
  { code: "H92", description: "Biomedicine & Bioengineering Research" },
  { code: "H94", description: "Geriatrics Research" },
  { code: "H96", description: "Neurology & Neuroscience Research" },
  { code: "H98", description: "Pediatrics Research" },
  { code: "H9B", description: "Surgery Research" },
  { code: "H99", description: "Medical Research - Other" },
  
  // I: Crime & Legal-Related
  { code: "I", description: "Crime & Legal-Related" },
  { code: "I01", description: "Alliances & Advocacy" },
  { code: "I02", description: "Management & Technical Assistance" },
  { code: "I03", description: "Professional Societies & Associations" },
  { code: "I05", description: "Research Institutes & Public Policy Analysis" },
  { code: "I11", description: "Single Organization Support" },
  { code: "I12", description: "Fund Raising & Fund Distribution" },
  { code: "I19", description: "Support - Other" },
  { code: "I20", description: "Crime Prevention" },
  { code: "I21", description: "Youth Violence Prevention" },
  { code: "I23", description: "Drunk Driving-Related" },
  { code: "I30", description: "Correctional Facilities" },
  { code: "I31", description: "Half-Way Houses for Offenders & Ex-Offenders" },
  { code: "I40", description: "Rehabilitation Services for Offenders" },
  { code: "I43", description: "Inmate Support" },
  { code: "I44", description: "Prison Alternatives" },
  { code: "I50", description: "Administration of Justice" },
  { code: "I51", description: "Dispute Resolution & Mediation" },
  { code: "I60", description: "Law Enforcement" },
  { code: "I70", description: "Protection Against Abuse" },
  { code: "I71", description: "Spouse Abuse Prevention" },
  { code: "I72", description: "Child Abuse Prevention" },
  { code: "I73", description: "Sexual Abuse Prevention" },
  { code: "I80", description: "Legal Services" },
  { code: "I83", description: "Public Interest Law" },
  { code: "I99", description: "Crime & Legal-Related - Other" },
  
  // J: Employment
  { code: "J", description: "Employment" },
  { code: "J01", description: "Alliances & Advocacy" },
  { code: "J02", description: "Management & Technical Assistance" },
  { code: "J03", description: "Professional Societies & Associations" },
  { code: "J05", description: "Research Institutes & Public Policy Analysis" },
  { code: "J11", description: "Single Organization Support" },
  { code: "J12", description: "Fund Raising & Fund Distribution" },
  { code: "J19", description: "Support - Other" },
  { code: "J20", description: "Employment Preparation & Procurement" },
  { code: "J21", description: "Vocational Counseling" },
  { code: "J22", description: "Job Training" },
  { code: "J30", description: "Vocational Rehabilitation" },
  { code: "J32", description: "Goodwill Industries" },
  { code: "J33", description: "Sheltered Employment" },
  { code: "J40", description: "Labor Unions" },
  { code: "J99", description: "Employment - Other" },
  
  // K: Food, Agriculture & Nutrition
  { code: "K", description: "Food, Agriculture & Nutrition" },
  { code: "K01", description: "Alliances & Advocacy" },
  { code: "K02", description: "Management & Technical Assistance" },
  { code: "K03", description: "Professional Societies & Associations" },
  { code: "K05", description: "Research Institutes & Public Policy Analysis" },
  { code: "K11", description: "Single Organization Support" },
  { code: "K12", description: "Fund Raising & Fund Distribution" },
  { code: "K19", description: "Support - Other" },
  { code: "K20", description: "Agricultural Programs" },
  { code: "K25", description: "Farmland Preservation" },
  { code: "K26", description: "Livestock Breeding, Development & Management" },
  { code: "K28", description: "Farm Bureau & Grange" },
  { code: "K30", description: "Food Programs" },
  { code: "K31", description: "Food Banks & Pantries" },
  { code: "K34", description: "Congregate Meals" },
  { code: "K35", description: "Soup Kitchens" },
  { code: "K36", description: "Meals on Wheels" },
  { code: "K40", description: "Nutrition" },
  { code: "K50", description: "Home Economics" },
  { code: "K99", description: "Food, Agriculture & Nutrition - Other" },
  
  // L: Housing & Shelter
  { code: "L", description: "Housing & Shelter" },
  { code: "L01", description: "Alliances & Advocacy" },
  { code: "L02", description: "Management & Technical Assistance" },
  { code: "L03", description: "Professional Societies & Associations" },
  { code: "L05", description: "Research Institutes & Public Policy Analysis" },
  { code: "L11", description: "Single Organization Support" },
  { code: "L12", description: "Fund Raising & Fund Distribution" },
  { code: "L19", description: "Support - Other" },
  { code: "L20", description: "Housing Development, Construction & Management" },
  { code: "L21", description: "Low-Income & Subsidized Rental Housing" },
  { code: "L22", description: "Senior Citizens' Housing & Retirement Communities" },
  { code: "L24", description: "Independent Housing for People with Disabilities" },
  { code: "L25", description: "Housing Rehabilitation" },
  { code: "L30", description: "Housing Search Assistance" },
  { code: "L40", description: "Temporary Housing" },
  { code: "L41", description: "Homeless Shelters" },
  { code: "L50", description: "Homeowners & Tenants Associations" },
  { code: "L80", description: "Housing Support" },
  { code: "L81", description: "Home Improvement & Repairs" },
  { code: "L82", description: "Housing Expense Reduction Support" },
  { code: "L99", description: "Housing & Shelter - Other" },
  
  // M: Public Safety, Disaster Preparedness & Relief
  { code: "M", description: "Public Safety, Disaster Preparedness & Relief" },
  { code: "M01", description: "Alliances & Advocacy" },
  { code: "M02", description: "Management & Technical Assistance" },
  { code: "M03", description: "Professional Societies & Associations" },
  { code: "M05", description: "Research Institutes & Public Policy Analysis" },
  { code: "M11", description: "Single Organization Support" },
  { code: "M12", description: "Fund Raising & Fund Distribution" },
  { code: "M19", description: "Support - Other" },
  { code: "M20", description: "Disaster Preparedness & Relief" },
  { code: "M23", description: "Search & Rescue Squads" },
  { code: "M24", description: "Fire Prevention" },
  { code: "M40", description: "Safety Education" },
  { code: "M41", description: "First Aid" },
  { code: "M42", description: "Automotive Safety" },
  { code: "M99", description: "Public Safety, Disaster Preparedness & Relief - Other" },
  
  // N: Recreation & Sports
  { code: "N", description: "Recreation & Sports" },
  { code: "N01", description: "Alliances & Advocacy" },
  { code: "N02", description: "Management & Technical Assistance" },
  { code: "N03", description: "Professional Societies & Associations" },
  { code: "N05", description: "Research Institutes & Public Policy Analysis" },
  { code: "N11", description: "Single Organization Support" },
  { code: "N12", description: "Fund Raising & Fund Distribution" },
  { code: "N19", description: "Support - Other" },
  { code: "N20", description: "Recreational Clubs" },
  { code: "N21", description: "Hunting & Fishing Clubs" },
  { code: "N30", description: "Physical Fitness & Community Recreational Facilities" },
  { code: "N31", description: "Community Recreational Centers" },
  { code: "N32", description: "Parks & Playgrounds" },
  { code: "N40", description: "Sports Training Facilities, Agencies" },
  { code: "N50", description: "Recreational, Pleasure or Social Clubs" },
  { code: "N52", description: "Country & Athletic Clubs" },
  { code: "N60", description: "Amateur Sports" },
  { code: "N61", description: "Fishing & Hunting" },
  { code: "N62", description: "Basketball" },
  { code: "N63", description: "Baseball & Softball" },
  { code: "N64", description: "Soccer" },
  { code: "N65", description: "Football" },
  { code: "N66", description: "Racquet Sports" },
  { code: "N67", description: "Swimming & Other Water Recreation" },
  { code: "N68", description: "Winter Sports" },
  { code: "N69", description: "Equestrian" },
  { code: "N6A", description: "Golf" },
  { code: "N70", description: "Amateur Sports Competitions" },
  { code: "N71", description: "Olympics" },
  { code: "N72", description: "Special Olympics" },
  { code: "N80", description: "Professional Athletic Leagues" },
  { code: "N99", description: "Recreation & Sports - Other" },
  
  // O: Youth Development
  { code: "O", description: "Youth Development" },
  { code: "O01", description: "Alliances & Advocacy" },
  { code: "O02", description: "Management & Technical Assistance" },
  { code: "O03", description: "Professional Societies & Associations" },
  { code: "O05", description: "Research Institutes & Public Policy Analysis" },
  { code: "O11", description: "Single Organization Support" },
  { code: "O12", description: "Fund Raising & Fund Distribution" },
  { code: "O19", description: "Support - Other" },
  { code: "O20", description: "Youth Centers & Clubs" },
  { code: "O21", description: "Boys Clubs" },
  { code: "O22", description: "Girls Clubs" },
  { code: "O23", description: "Boys & Girls Clubs" },
  { code: "O30", description: "Adult & Child Matching Programs" },
  { code: "O31", description: "Big Brothers & Big Sisters" },
  { code: "O40", description: "Scouting" },
  { code: "O41", description: "Boy Scouts of America" },
  { code: "O42", description: "Girl Scouts of the USA" },
  { code: "O43", description: "Camp Fire" },
  { code: "O50", description: "Youth Development Programs" },
  { code: "O51", description: "Youth Community Service Clubs" },
  { code: "O52", description: "Agricultural Youth Development" },
  { code: "O53", description: "Business Youth Development" },
  { code: "O54", description: "Citizenship Programs" },
  { code: "O55", description: "Religious Leadership Development" },
  { code: "O99", description: "Youth Development - Other" },
  
  // P: Human Services
  { code: "P", description: "Human Services" },
  { code: "P01", description: "Alliances & Advocacy" },
  { code: "P02", description: "Management & Technical Assistance" },
  { code: "P03", description: "Professional Societies & Associations" },
  { code: "P05", description: "Research Institutes & Public Policy Analysis" },
  { code: "P11", description: "Single Organization Support" },
  { code: "P12", description: "Fund Raising & Fund Distribution" },
  { code: "P19", description: "Support - Other" },
  { code: "P20", description: "Human Services" },
  { code: "P21", description: "American Red Cross" },
  { code: "P22", description: "Urban League" },
  { code: "P24", description: "Salvation Army" },
  { code: "P26", description: "Volunteers of America" },
  { code: "P27", description: "Young Men's or Women's Associations" },
  { code: "P28", description: "Neighborhood Centers" },
  { code: "P29", description: "Thrift Shops" },
  { code: "P30", description: "Children & Youth Services" },
  { code: "P31", description: "Adoption" },
  { code: "P32", description: "Foster Care" },
  { code: "P33", description: "Child Day Care" },
  { code: "P40", description: "Family Services" },
  { code: "P42", description: "Single Parent Agencies" },
  { code: "P43", description: "Family Violence Shelters, Services" },
  { code: "P44", description: "Homemaker Services" },
  { code: "P45", description: "Family Services" },
  { code: "P46", description: "Family Counseling" },
  { code: "P50", description: "Personal Social Services" },
  { code: "P51", description: "Financial Counseling" },
  { code: "P52", description: "Transportation Assistance" },
  { code: "P58", description: "Gift Distribution" },
  { code: "P60", description: "Emergency Assistance" },
  { code: "P61", description: "Travelers' Aid" },
  { code: "P62", description: "Victims' Services" },
  { code: "P70", description: "Residential Care & Adult Day Programs" },
  { code: "P71", description: "Adult Day Care" },
  { code: "P73", description: "Group Homes" },
  { code: "P74", description: "Hospices" },
  { code: "P75", description: "Supportive Housing for Older Adults" },
  { code: "P80", description: "Centers to Support the Independence of Specific Populations" },
  { code: "P81", description: "Senior Centers" },
  { code: "P82", description: "Developmentally Disabled Centers" },
  { code: "P84", description: "Ethnic & Immigrant Centers" },
  { code: "P85", description: "Homeless Centers" },
  { code: "P86", description: "Blind & Visually Impaired Centers" },
  { code: "P87", description: "Deaf & Hearing Impaired Centers" },
  { code: "P99", description: "Human Services - Other" },
  
  // Q: International, Foreign Affairs & National Security
  { code: "Q", description: "International, Foreign Affairs & National Security" },
  { code: "Q01", description: "Alliances & Advocacy" },
  { code: "Q02", description: "Management & Technical Assistance" },
  { code: "Q03", description: "Professional Societies & Associations" },
  { code: "Q05", description: "Research Institutes & Public Policy Analysis" },
  { code: "Q11", description: "Single Organization Support" },
  { code: "Q12", description: "Fund Raising & Fund Distribution" },
  { code: "Q19", description: "Support - Other" },
  { code: "Q20", description: "Promotion of International Understanding" },
  { code: "Q21", description: "International Cultural Exchange" },
  { code: "Q22", description: "International Academic Exchange" },
  { code: "Q23", description: "International Exchange" },
  { code: "Q30", description: "International Development" },
  { code: "Q31", description: "International Agricultural Development" },
  { code: "Q32", description: "International Economic Development" },
  { code: "Q33", description: "International Relief" },
  { code: "Q40", description: "International Peace & Security" },
  { code: "Q41", description: "Arms Control & Peace" },
  { code: "Q42", description: "United Nations Associations" },
  { code: "Q43", description: "National Security" },
  { code: "Q70", description: "International Human Rights" },
  { code: "Q71", description: "International Migration & Refugee Issues" },
  { code: "Q99", description: "International, Foreign Affairs & National Security - Other" },
  
  // R: Civil Rights, Social Action & Advocacy
  { code: "R", description: "Civil Rights, Social Action & Advocacy" },
  { code: "R01", description: "Alliances & Advocacy" },
  { code: "R02", description: "Management & Technical Assistance" },
  { code: "R03", description: "Professional Societies & Associations" },
  { code: "R05", description: "Research Institutes & Public Policy Analysis" },
  { code: "R11", description: "Single Organization Support" },
  { code: "R12", description: "Fund Raising & Fund Distribution" },
  { code: "R19", description: "Support - Other" },
  { code: "R20", description: "Civil Rights" },
  { code: "R22", description: "Minority Rights" },
  { code: "R23", description: "Disabled Persons' Rights" },
  { code: "R24", description: "Women's Rights" },
  { code: "R25", description: "Seniors' Rights" },
  { code: "R26", description: "Lesbian & Gay Rights" },
  { code: "R30", description: "Intergroup & Race Relations" },
  { code: "R40", description: "Voter Education & Registration" },
  { code: "R60", description: "Civil Liberties" },
  { code: "R61", description: "Reproductive Rights" },
  { code: "R62", description: "Right to Life" },
  { code: "R63", description: "Censorship, Freedom of Speech & Press" },
  { code: "R67", description: "Right to Die & Euthanasia" },
  { code: "R99", description: "Civil Rights, Social Action & Advocacy - Other" },
  
  // S: Community Improvement & Capacity Building
  { code: "S", description: "Community Improvement & Capacity Building" },
  { code: "S01", description: "Alliances & Advocacy" },
  { code: "S02", description: "Management & Technical Assistance" },
  { code: "S03", description: "Professional Societies & Associations" },
  { code: "S05", description: "Research Institutes & Public Policy Analysis" },
  { code: "S11", description: "Single Organization Support" },
  { code: "S12", description: "Fund Raising & Fund Distribution" },
  { code: "S19", description: "Support - Other" },
  { code: "S20", description: "Community & Neighborhood Development" },
  { code: "S21", description: "Community Coalitions" },
  { code: "S22", description: "Neighborhood & Block Associations" },
  { code: "S30", description: "Economic Development" },
  { code: "S31", description: "Urban & Community Economic Development" },
  { code: "S32", description: "Rural Development" },
  { code: "S40", description: "Business & Industry" },
  { code: "S41", description: "Promotion of Business" },
  { code: "S43", description: "Small Business Development" },
  { code: "S46", description: "Boards of Trade & Chambers of Commerce" },
  { code: "S47", description: "Real Estate Organizations" },
  { code: "S50", description: "Nonprofit Management" },
  { code: "S80", description: "Community Service Clubs" },
  { code: "S81", description: "Women's Service Clubs" },
  { code: "S82", description: "Men's Service Clubs" },
  { code: "S99", description: "Community Improvement & Capacity Building - Other" },
  
  // T: Philanthropy, Voluntarism & Grantmaking Foundations
  { code: "T", description: "Philanthropy, Voluntarism & Grantmaking Foundations" },
  { code: "T01", description: "Alliances & Advocacy" },
  { code: "T02", description: "Management & Technical Assistance" },
  { code: "T03", description: "Professional Societies & Associations" },
  { code: "T05", description: "Research Institutes & Public Policy Analysis" },
  { code: "T11", description: "Single Organization Support" },
  { code: "T12", description: "Fund Raising & Fund Distribution" },
  { code: "T19", description: "Support - Other" },
  { code: "T20", description: "Private Grantmaking Foundations" },
  { code: "T21", description: "Corporate Foundations" },
  { code: "T22", description: "Private Independent Foundations" },
  { code: "T23", description: "Private Operating Foundations" },
  { code: "T30", description: "Public Foundations" },
  { code: "T31", description: "Community Foundations" },
  { code: "T40", description: "Voluntarism Promotion" },
  { code: "T50", description: "Philanthropy, Charity & Voluntarism Promotion" },
  { code: "T70", description: "Federated Giving Programs" },
  { code: "T90", description: "Named Trusts" },
  { code: "T99", description: "Philanthropy, Voluntarism & Grantmaking Foundations - Other" },
  
  // U: Science & Technology
  { code: "U", description: "Science & Technology" },
  { code: "U01", description: "Alliances & Advocacy" },
  { code: "U02", description: "Management & Technical Assistance" },
  { code: "U03", description: "Professional Societies & Associations" },
  { code: "U05", description: "Research Institutes & Public Policy Analysis" },
  { code: "U11", description: "Single Organization Support" },
  { code: "U12", description: "Fund Raising & Fund Distribution" },
  { code: "U19", description: "Support - Other" },
  { code: "U20", description: "General Science" },
  { code: "U21", description: "Marine Science & Oceanography" },
  { code: "U30", description: "Physical & Earth Sciences" },
  { code: "U31", description: "Astronomy" },
  { code: "U33", description: "Chemistry & Chemical Engineering" },
  { code: "U34", description: "Mathematics" },
  { code: "U36", description: "Geology" },
  { code: "U40", description: "Engineering & Technology" },
  { code: "U41", description: "Computer Science" },
  { code: "U42", description: "Engineering" },
  { code: "U50", description: "Biological & Life Sciences" },
  { code: "U99", description: "Science & Technology - Other" },
  
  // V: Social Science
  { code: "V", description: "Social Science" },
  { code: "V01", description: "Alliances & Advocacy" },
  { code: "V02", description: "Management & Technical Assistance" },
  { code: "V03", description: "Professional Societies & Associations" },
  { code: "V05", description: "Research Institutes & Public Policy Analysis" },
  { code: "V11", description: "Single Organization Support" },
  { code: "V12", description: "Fund Raising & Fund Distribution" },
  { code: "V19", description: "Support - Other" },
  { code: "V20", description: "Social Science" },
  { code: "V21", description: "Anthropology & Sociology" },
  { code: "V22", description: "Economics" },
  { code: "V23", description: "Behavioral Science" },
  { code: "V24", description: "Political Science" },
  { code: "V25", description: "Population Studies" },
  { code: "V26", description: "Law & Jurisprudence" },
  { code: "V30", description: "Interdisciplinary Research" },
  { code: "V31", description: "Black Studies" },
  { code: "V32", description: "Women's Studies" },
  { code: "V33", description: "Ethnic Studies" },
  { code: "V34", description: "Urban Studies" },
  { code: "V35", description: "International Studies" },
  { code: "V36", description: "Gerontology" },
  { code: "V37", description: "Labor Studies" },
  { code: "V99", description: "Social Science - Other" },
  
  // W: Public & Societal Benefit
  { code: "W", description: "Public & Societal Benefit" },
  { code: "W01", description: "Alliances & Advocacy" },
  { code: "W02", description: "Management & Technical Assistance" },
  { code: "W03", description: "Professional Societies & Associations" },
  { code: "W05", description: "Research Institutes & Public Policy Analysis" },
  { code: "W11", description: "Single Organization Support" },
  { code: "W12", description: "Fund Raising & Fund Distribution" },
  { code: "W19", description: "Support - Other" },
  { code: "W20", description: "Government & Public Administration" },
  { code: "W22", description: "Public Finance, Taxation & Monetary Policy" },
  { code: "W24", description: "Citizen Participation" },
  { code: "W30", description: "Military & Veterans Organizations" },
  { code: "W40", description: "Public Transportation Systems" },
  { code: "W50", description: "Telecommunications" },
  { code: "W60", description: "Financial Institutions" },
  { code: "W61", description: "Credit Unions" },
  { code: "W70", description: "Leadership Development" },
  { code: "W80", description: "Public Utilities" },
  { code: "W90", description: "Consumer Protection" },
  { code: "W99", description: "Public & Societal Benefit - Other" },
  
  // X: Religion-Related
  { code: "X", description: "Religion-Related" },
  { code: "X01", description: "Alliances & Advocacy" },
  { code: "X02", description: "Management & Technical Assistance" },
  { code: "X03", description: "Professional Societies & Associations" },
  { code: "X05", description: "Research Institutes & Public Policy Analysis" },
  { code: "X11", description: "Single Organization Support" },
  { code: "X12", description: "Fund Raising & Fund Distribution" },
  { code: "X19", description: "Support - Other" },
  { code: "X20", description: "Christianity" },
  { code: "X21", description: "Protestant" },
  { code: "X22", description: "Roman Catholic" },
  { code: "X30", description: "Judaism" },
  { code: "X40", description: "Islam" },
  { code: "X50", description: "Buddhism" },
  { code: "X70", description: "Hinduism" },
  { code: "X80", description: "Religious Media & Communications" },
  { code: "X81", description: "Religious Film & Video" },
  { code: "X82", description: "Religious Television" },
  { code: "X83", description: "Religious Printing & Publishing" },
  { code: "X84", description: "Religious Radio" },
  { code: "X90", description: "Interfaith Coalitions" },
  { code: "X99", description: "Religion-Related - Other" },
  
  // Y: Mutual & Membership Benefit
  { code: "Y", description: "Mutual & Membership Benefit" },
  { code: "Y01", description: "Alliances & Advocacy" },
  { code: "Y02", description: "Management & Technical Assistance" },
  { code: "Y03", description: "Professional Societies & Associations" },
  { code: "Y05", description: "Research Institutes & Public Policy Analysis" },
  { code: "Y11", description: "Single Organization Support" },
  { code: "Y12", description: "Fund Raising & Fund Distribution" },
  { code: "Y19", description: "Support - Other" },
  { code: "Y20", description: "Insurance Providers" },
  { code: "Y22", description: "Local Benevolent Life Insurance Associations" },
  { code: "Y23", description: "Mutual Insurance Companies & Associations" },
  { code: "Y24", description: "Supplemental Unemployment Compensation" },
  { code: "Y25", description: "State-Sponsored Worker's Compensation Insurance" },
  { code: "Y30", description: "Pension & Retirement Funds" },
  { code: "Y33", description: "Teacher's Retirement Fund" },
  { code: "Y34", description: "Employee's Retirement Association" },
  { code: "Y35", description: "Fraternal Beneficiary Societies" },
  { code: "Y40", description: "Fraternal Societies & Orders" },
  { code: "Y42", description: "Domestic Fraternal Societies & Orders" },
  { code: "Y43", description: "Voluntary Employees Beneficiary Associations" },
  { code: "Y44", description: "Voluntary Employees Beneficiary Association, Supplement Unemployment Benefits" },
  { code: "Y50", description: "Cemeteries" },
  { code: "Y99", description: "Mutual & Membership Benefit - Other" },
  
  // Z: Unknown
  { code: "Z", description: "Unknown" },
  { code: "Z99", description: "Unknown" },
  { code: "Z99.1", description: "Unknown - 501(c)(3) status with IRS" },
  { code: "Z99.2", description: "Unknown - status with IRS other than 501(c)(3)" }
];

export default NTEECodes;